"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterHighlightVfxCameraAction = exports.AlphaVfxCameraAction = exports.RotateVfxCameraAction = exports.ZoomVfxCameraAction = exports.EffectVfxCameraAction = void 0;
class EffectVfxCameraAction {
    constructor(effect) {
        this.effect = effect;
        this.__typeName = "Effect";
    }
}
exports.EffectVfxCameraAction = EffectVfxCameraAction;
class ZoomVfxCameraAction {
    constructor(zoom) {
        this.zoom = zoom;
        this.__typeName = "Zoom";
    }
}
exports.ZoomVfxCameraAction = ZoomVfxCameraAction;
ZoomVfxCameraAction.Default = new ZoomVfxCameraAction(1);
class RotateVfxCameraAction {
    constructor(degrees) {
        this.degrees = degrees;
        this.__typeName = "Rotate";
    }
}
exports.RotateVfxCameraAction = RotateVfxCameraAction;
RotateVfxCameraAction.Default = new RotateVfxCameraAction(0);
class AlphaVfxCameraAction {
    constructor(alpha) {
        this.alpha = alpha;
        this.__typeName = "Alpha";
    }
}
exports.AlphaVfxCameraAction = AlphaVfxCameraAction;
AlphaVfxCameraAction.Default = new AlphaVfxCameraAction(1);
// TODO: WIP
class CharacterHighlightVfxCameraAction {
    constructor(actorId, reset) {
        this.actorId = actorId;
        this.reset = reset;
        this.__typeName = "CharacterHighlight";
    }
}
exports.CharacterHighlightVfxCameraAction = CharacterHighlightVfxCameraAction;
CharacterHighlightVfxCameraAction.WithReset = (actorId) => ({
    applyHighlightVfx: new CharacterHighlightVfxCameraAction(actorId, false),
    resetHighlightVfx: new CharacterHighlightVfxCameraAction(actorId, true),
});
